module.exports = __webpack_public_path__ + "static/media/3.aff1b7eb.jpg";